export default {
    dateFrom: '',
    dateTo: '',
    gameTypeId: 0,
    isAggregate: true,
    isDateRangeFromSeasons: false,
    franchiseId: '',
    positionCode: '',
    reportName: '',
    seasonFrom: 0,
    seasonTo: 0,
    timeFrame: 'season',
};
